import React from 'react'
import GlobalBreadcrumbs from '../../components/global/GlobalBreadcrumbs'
import WrapperSection from '../../components/global/WrapperSection'
import FormAddEditRoles from '../../components/Roles/FormAddEditRoles'
import { useGetRole } from '../../hooks/roles/useGetRole'
import { useParams } from 'react-router-dom'
import LoadingPage from '../../components/global/LoadingPage'

const EditRoles = () => {
    const { id } = useParams();
    const { Role, isLoading } = useGetRole(id);
    if (isLoading) return <LoadingPage />;
    const role = Role?.data;
    return (
        <>
            <WrapperSection>
                <GlobalBreadcrumbs />
                <FormAddEditRoles currentData={role} isEdit={true} />
            </WrapperSection>
        </>
    )
}

export default EditRoles